module.exports = __webpack_public_path__ + "img/partner5.37924bfd.jpg";